
import { supabase } from '@/integrations/supabase/client';

export const usePostOperations = () => {
  const deletePost = async (postId: string | number) => {
    console.log('=== DELETE POST DEBUG START ===');
    console.log('Post ID to delete:', postId);
    
    const { data: { user } } = await supabase.auth.getUser();
    console.log('Current user:', user?.id);
    
    const postIdString = typeof postId === 'number' ? postId.toString() : postId;
    console.log('Post ID as string:', postIdString);
    
    if (user) {
      console.log('Attempting database delete...');
      const { error, data } = await supabase
        .from('posts')
        .delete()
        .eq('id', postIdString)
        .eq('user_id', user.id);

      console.log('Delete result - error:', error);
      console.log('Delete result - data:', data);

      if (error) {
        console.error('Database delete error:', error);
        throw error;
      }
      
      console.log('Delete successful in database');
    } else {
      console.log('No user found - cannot delete');
    }
    
    console.log('=== DELETE POST DEBUG END ===');
    return true;
  };

  const updatePost = async (updatedPost: any) => {
    const { data: { user } } = await supabase.auth.getUser();
    
    if (user) {
      const { error } = await supabase
        .from('posts')
        .update({
          content: updatedPost.content,
          crop_type: updatedPost.crop,
          sentiment: updatedPost.sentiment,
          whats_happening: updatedPost.whatsHappening,
          challenges: updatedPost.challenges,
          harvest_week_month: updatedPost.harvestWeekMonth
        })
        .eq('id', updatedPost.id)
        .eq('user_id', user.id);

      if (error) {
        console.error('Database update error:', error);
        throw error;
      }
    }
    
    return true;
  };

  const toggleLike = async (postId: string) => {
    const { data: { user } } = await supabase.auth.getUser();
    if (!user) return;

    const { data: existingLike } = await supabase
      .from('post_likes')
      .select('id')
      .eq('post_id', postId)
      .eq('user_id', user.id)
      .single();

    if (existingLike) {
      await supabase
        .from('post_likes')
        .delete()
        .eq('post_id', postId)
        .eq('user_id', user.id);
    } else {
      await supabase
        .from('post_likes')
        .insert({
          post_id: postId,
          user_id: user.id
        });
    }
  };

  return {
    deletePost,
    updatePost,
    toggleLike
  };
};
